const DRAWN_TAGS = new Set(['IMG', 'svg', 'CANVAS', 'VIDEO', 'INPUT', 'BUTTON', 'SELECT', 'TEXTAREA', 'IFRAME']);
const BORDERS = ['borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth'];

const isSet = value => Boolean(value) && value !== 'none' && value !== 'normal';

const isTransparent = color => !color || color === 'transparent' || /^rgba\(.*,\s*0\)$/.test(color);

const isOnScreen = (rect, view) => rect.height > 0 && rect.right > 0 && rect.left < view.innerWidth;

const drawsBox = (element, view) => {
  const style = view.getComputedStyle(element);
  if (style.visibility === 'hidden') {
    return false;
  }
  return [
    DRAWN_TAGS.has(element.tagName),
    isSet(style.backgroundImage),
    !isTransparent(style.backgroundColor),
    BORDERS.some(border => Number.parseFloat(style[border]) > 0),
    isSet(style.boxShadow),
    ['::before', '::after'].some(pseudo => isSet(view.getComputedStyle(element, pseudo).content)),
  ].some(Boolean);
};

export default function getCardFrameHeight(doc) {
  const view = doc.defaultView;
  const range = doc.createRange();
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_ALL);
  let bottom = 0;
  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    let rect = null;
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.trim() && view.getComputedStyle(node.parentElement).visibility !== 'hidden') {
        range.selectNodeContents(node);
        rect = range.getBoundingClientRect();
      }
    } else if (node.nodeType === Node.ELEMENT_NODE && drawsBox(node, view)) {
      rect = node.getBoundingClientRect();
    }
    if (rect && isOnScreen(rect, view)) {
      bottom = Math.max(bottom, rect.bottom);
    }
  }
  const { paddingBottom, marginBottom } = view.getComputedStyle(doc.body);
  return Math.ceil(bottom + (Number.parseFloat(paddingBottom) || 0) + (Number.parseFloat(marginBottom) || 0));
}
